import { jsxs as c, jsx as a } from "react/jsx-runtime";
import i from "./index.es2478.js";
import { ROTATE_CONVERSION as p } from "./index.es2479.js";
import m from "classnames";
const e = ({
  direction: n,
  disabled: t,
  onClick: r,
  testId: o,
  ...s
}) => {
  const l = { transform: `rotate(${p[n]}deg)` }, d = t ? "var(--plac-primary-disabled)" : "var(--plac-primary-gray)";
  return /* @__PURE__ */ a(
    "button",
    {
      className: m(i.arrowButton, { [i.disabled]: t }),
      onClick: r,
      "data-testid": o,
      disabled: t,
      ...s,
      children: /* @__PURE__ */ a(
        "svg",
        {
          width: "6",
          height: "10",
          viewBox: "0 0 6 10",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          style: l,
          children: /* @__PURE__ */ a(
            "path",
            {
              d: "M1 9L5 5L1 1",
              stroke: d,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        }
      )
    }
  );
}, h = ({
  onLeftClick: n,
  onRightClick: t,
  arrivedToLimit: r,
  testId: o
}) => /* @__PURE__ */ c("div", { className: i.buttonsContainer, "data-testid": o, children: [
  /* @__PURE__ */ a(
    e,
    {
      disabled: r === "left",
      onClick: n,
      direction: "up",
      testId: `${o}-up-button`,
      "aria-label": "paginate backwards"
    }
  ),
  /* @__PURE__ */ a(
    e,
    {
      disabled: r === "right",
      onClick: t,
      "aria-label": "paginate forwards",
      direction: "down",
      testId: `${o}-down-button`
    }
  )
] });
export {
  h as ContactNavigationButtons,
  e as NavigationButton
};
//# sourceMappingURL=index.es804.js.map
